import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {CommonService} from "../services/common.service";

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordGuard  {
  constructor(
    private router: Router,
    private commonService: CommonService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route.queryParams?.['token']) {
      this.commonService.setPasswordToken(route.queryParams?.['token'])
    }

    const isRestPasswordTokenPresent = this.commonService.isPasswordTokenPresent(); // ... your authentication logic here

    if (isRestPasswordTokenPresent) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }

}
